import colors from 'vuetify/lib/util/colors'

export default {
  themes: {
    light: {
      textBlack: '#404040',
      textGrey: '#616161',
    },
    dark: {
      textBlack: colors.white,
      textGrey: colors.white,
    },
  },
}
